"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ironFurnaceConfig = void 0;
exports.ironFurnaceConfig = {
    name: 'iron-furnace',
    fullname: 'Iron Furnace',
    description: 'Converts iron ore into iron ingots.',
    type: 'factory',
    width: 1,
    height: 1,
    levelMax: 5,
    canBeDisabled: true,
    requiredTechnology: 'iron',
    levels: [
        { level: 0, constructionCosts: {}, time: 100, provides: { iron: 1 }, costs: { energy: 1, 'iron-ore': 1 }, stores: {} },
        { level: 1, constructionCosts: { stone: 30 }, time: 80, provides: { iron: 1 }, costs: { energy: 1, 'iron-ore': 1 }, stores: {} },
        { level: 2, constructionCosts: { stone: 50 }, time: 60, provides: { iron: 1 }, costs: { energy: 1, 'iron-ore': 1 }, stores: {} },
        { level: 3, constructionCosts: { iron: 50, stone: 50 }, time: 30, provides: { iron: 1 }, costs: { energy: 1, 'iron-ore': 1 }, stores: {} },
        { level: 4, constructionCosts: { iron: 100, stone: 100 }, time: 10, provides: { iron: 1 }, costs: { energy: 1, 'iron-ore': 1 }, stores: {} },
        { level: 5, constructionCosts: { iron: 1000, stone: 1000 }, time: 5, provides: { iron: 2 }, costs: { energy: 1, 'iron-ore': 2 }, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/ironfurnace.js
// module id = lu5J
// module chunks = 0